import qs from "qs";

import { axiosWithAuth, convertDateToISO, TIME_OFFSET_DAY_END } from "helpers";

export const merchantListService = {
	getMerchantList,
	getStatusList,
	getAgentList,
	getCompanyUsers,
	getCompanyList,
	getStates,
	getMerchant,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getStatusList() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/merchants/merchantStatuses`,
	};

	return axiosWithAuth(options);
}

function getCompanyList() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/merchants/companies`,
	};

	return axiosWithAuth(options);
}

function getStates() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/dropdown/merchant/states`,
	};

	return axiosWithAuth(options);
}

function getAgentList(pattern, page, isActive, companyId) {
	const options = {
		method: "POST",
		data: {
			pattern,
			isActive,
			companyId,
			page,
			pageSize: 20,
		},
		url: `${API_URL}/api/merchants/agents`,
	};

	return axiosWithAuth(options);
}

function getCompanyUsers(companyId) {
	const options = {
		method: "POST",
		data: { companyId },
		url: `${API_URL}/api/dropdown/merchants/companyUsers`,
	};

	return axiosWithAuth(options);
}

function getMerchantList({ page, sort, filtersApplied }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			approved_from: convertDateToISO(filtersApplied?.approvedDate?.[0]),
			approved_to: convertDateToISO(filtersApplied?.approvedDate?.[1], {
				addTime: TIME_OFFSET_DAY_END,
			}),
			closed_from: convertDateToISO(filtersApplied?.closedDate?.[0]),
			closed_to: convertDateToISO(filtersApplied?.closedDate?.[1], {
				addTime: TIME_OFFSET_DAY_END,
			}),
			is_high_risk: filtersApplied?.isHighRisk?.id,
			name: filtersApplied?.name,
			state_id: filtersApplied?.states?.id,
			mid: filtersApplied?.mid,
			city: filtersApplied?.city,
			is_only_parent: filtersApplied?.isOnlyParent ? true : undefined,
			is_aurora_house_account: filtersApplied?.isAuroraHouseAccount
				? true
				: undefined,
			skip_merchants: filtersApplied?.skipMerchants,
			processor_id: filtersApplied?.processor?.id,
			sponsor_id: filtersApplied?.sponsor?.id,
			agent_ids: filtersApplied?.agents?.map(
				item => item.id || item.value,
			),
			agent_office: filtersApplied?.agentOffice,
			merchant_status_id: filtersApplied?.status?.id,
			category: filtersApplied?.category,
			priority_type: filtersApplied?.priorityType?.value,
			agent_office_package: filtersApplied?.agentOfficePackage?.value,
			sort_type: sort?.id || undefined,
			ascending: sort?.desc,
			search_for: filtersApplied?.search_for,
		},
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
		url: `${API_URL}/api/merchants`,
	};

	return axiosWithAuth(options);
}

function getMerchant(mid) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/merchants/${mid}`,
	};

	return axiosWithAuth(options);
}
